<style>
    .session-items {
        display: flex;
        flex-direction: column;
    }

    .session-items a {
        padding: 5px;
        font-size: 1.0em;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        cursor: pointer;
        transition: all 200ms;
    }

    .session-items a:hover {
        background-color: #f0f0f0;
    }

    .modal-header-close-btn {
        font-size: 2.0em;
    }
</style>

<template>
    <div>

        <div id="session-modal" ref="newSessionModal" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div :class="'modal-header bg-' + currentTraining?.module?.color">
                        <span class="text-white">
                             {{ title }}
                        </span>
                        <button type="button" class="modal-header-close-btn" data-dismiss="modal" aria-label="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!showContent">
                            <div v-if="showAddTrainingSession">
                                <add-training-session
                                    :training-id="trainingId"
                                    :new-session="newSession"
                                ></add-training-session>
                            </div>
                            <div v-else class="session-items">
                                <a @click="handleSessionItemClick('Play Video')" tabindex="0" @keyup.enter="handleSessionItemClick('Play Video')">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z"/></svg>
                                    Play Video
                                </a>
                                <a @click="handleSessionItemClick('Knowledge Quiz')" tabindex="0" @keyup.enter="handleSessionItemClick('Knowledge Quiz')">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/></svg>
                                    Knowledge Quiz
                                </a>
                                <a @click="handleSessionItemClick('Evaluation')" tabindex="0" @keyup.enter="handleSessionItemClick('Evaluation')">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"/></svg>
                                    Evaluation
                                </a>
                            </div>
                        </div>
                        <div v-else class="session-content">
                            <component :is="currentComponent" 
                                :training-session-id="currentSession.id"
                                :training-id="trainingId"
                                :is-dev="isDev"
                                v-bind="componentProps"
                            ></component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import AddTrainingSession from './AddTrainingSession';
    import TrainingVideoEmbed from './TrainingVideoEmbed';
    import PanoptoVideoEmbed from '../PanoptoVideoEmbed.vue';
    import ProviderTrainingKnowledgeQuiz from './ProviderTrainingKnowledgeQuiz';
    import ProviderTrainingEvaluation from './ProviderTrainingEvaluation';
    import ProviderTrainingCertificatePrint from './ProviderTrainingCertificatePrint';
    import BuildTheSkillsAssessment from './BuildTheSkillsAssessment.vue';
    import Auth from '../../auth.js';
    import { mapGetters, mapState, mapMutations } from 'vuex';

    export default {
        components: {
            AddTrainingSession,
            TrainingVideoEmbed,
            PanoptoVideoEmbed,
            ProviderTrainingKnowledgeQuiz,
            ProviderTrainingEvaluation,
            ProviderTrainingCertificatePrint,
            BuildTheSkillsAssessment,
        },
        props:[
        ],
        data() {
            return {
                newSession: true,
                isDev: false,
            };
        },
        methods: {
            handleSessionItemClick(option) {
                switch (option) {
                    case 'Play Video':
                        this.setCurrentContent('training-video-embed');
                        break;
                    case 'Knowledge Quiz':
                        this.setCurrentContent('provider-training-knowledge-quiz');
                        break;
                    case 'Evaluation':
                        this.setCurrentContent('provider-training-evaluation');
                        break;
                    default:
                        console.log("not an option");
                        break;
                }
            },
            setCurrentContent(component) {
                this.setCurrentContentComponent({currentContentComponent: component});
                this.setShowContent({showContent: true});
            },
            handleDismissModal() {
                this.setShowContent({showContent: false});
            },
            ...mapMutations({
                setCurrentContentComponent: 'SET_CURRENT_CONTENT_COMPONENT',
                setShowContent: 'SET_SHOW_CONTENT'
            }),
        },
        computed: {
            trainingSessionsForMenu: function() {
                return this.trainingSessionsForTraining(this.trainingId).filter((s,i) => {
                    return !s.is_finalized;
                });
            },
            trainingId: function() {
                return this.currentTrainingId;
            },
            currentTraining: function() {
                if(this.trainings) {
                    return this.trainings[this.trainingId];
                }
                return null;
            },
            trainingSessionId: function() {
                return this.currentSession.id;
            },
            currentSession: function() {
                return this.currentTrainingSession;
            },
            title: function() {
                if(this.showAddTrainingSession) {
                    return "Add New Training Session";
                } else {
                    return this.currentSession.title;
                }
            },
            currentComponent: function() {
                return this.currentContentComponent;
            },
            componentProps: function() {
                return {
                    'video-id': '5c0b538b-a8d1-4e1f-9a18-b09d0113018a',
                    'user': this.user,
                }
            },
            user: function() {
                return Auth.user;
            },
            ...mapState([
                'latestQuizResponses',
                'latestEvaluationResponses',
                'currentTrainingId',
                'showAddTrainingSession',
                'currentTrainingSession',
                'currentContentComponent',
                'showContent',
                'trainings',
            ]),
            ...mapGetters([
                'trainingSessionsForTraining'
            ]),
        },
        mounted() {
            let vm = this;
            $('#session-modal').on('hidden.bs.modal', e => vm.handleDismissModal());
        },
    }
</script>